import clsx from 'clsx'

interface CardProps {
  children: React.ReactNode
  className?: string
  variant?: 'default' | 'elevated' | 'outlined'
  padding?: 'sm' | 'md' | 'lg'
}

export function Card({ 
  children, 
  className, 
  variant = 'default',
  padding = 'md'
}: CardProps) {
  const baseClasses = 'rounded-2xl'
  
  const variantClasses = {
    default: 'bg-white border border-slate-200',
    elevated: 'bg-white shadow-xl ring-1 ring-slate-900/5',
    outlined: 'bg-white border-2 border-slate-200'
  }
  
  const paddingClasses = {
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8'
  }

  return (
    <div
      className={clsx(
        baseClasses,
        variantClasses[variant],
        paddingClasses[padding],
        className
      )}
    >
      {children}
    </div>
  )
}

interface CardHeaderProps {
  children: React.ReactNode
  className?: string
}

export function CardHeader({
 children, className 
}: CardHeaderProps) {
  return (
    <div className={clsx('mb-4', className)}>
      {children}
    </div>
  )
}

interface CardContentProps {
  children: React.ReactNode
  className?: string
}

export function CardContent({
 children, className 
}: CardContentProps) {
  return (
    <div className={className}>
      {children}
    </div>
  )
}

interface CardFooterProps {
  children: React.ReactNode
  className?: string
}

export function CardFooter({
 children, className 
}: CardFooterProps) {
  return (
    <div className={clsx('mt-6 pt-6 border-t border-slate-200', className)}>
      {children}
    </div>
  )
} 